import BillingList from "components/Dashboard/components/billing-list/BillingList";
import { useEffect, useState } from "react";
import { Button, Table, Tabs, Tab } from "react-bootstrap";
import BillsOverview from "./components/bills-overview";
import Sessions from "./components/sessions";

import { useTimeOnPageContext } from "contexts/time-on-page";
import { useUser } from "contexts/UserContext";
import { AmplitudePageName, track } from "utils/amplitude";
import getClasses from "utils/getClasses";
import styles from "./BusinessAnalytics.module.scss";
import loginToStripe from "services/loginToStripe";

const AMPLITUDE_PAGE_NAME: AmplitudePageName = "pro-business-analytics";

const BusinessAnalytics = () => {
  const { user } = useUser();

  const { setPage } = useTimeOnPageContext();
  useEffect(() => setPage(AMPLITUDE_PAGE_NAME), [setPage]);

  const [activeTab, setActiveTab] = useState("receipt");

  const goToStripe = async () => {
    try {
      const { url } = await loginToStripe();
      window.open(url, "_blank");
    } catch (error) {
      console.error(error);
    }
  };
  return (
    <div className={styles["billing"]}>
      <h4 className={styles["billing__title"]}>Bills</h4>
      <div className={styles["billing__sub-title"]}>Overview of your bills</div>
      <BillsOverview amplitudePageName={AMPLITUDE_PAGE_NAME} />
      <Tabs
        activeKey={activeTab}
        onSelect={(k) => setActiveTab(k!)}
        id="billing-tabs"
        className={styles["billing__tabs"]}
      >
        <Tab eventKey="receipt" title="Receipt" />
        <Tab eventKey="superbill" title="Superbill" />
      </Tabs>
      <BillingList
        amplitudePageName={AMPLITUDE_PAGE_NAME}
        activeTab={activeTab}
      />
      <hr className={styles["billing__hr"]} />
      <h4 className={styles["billing__title"]}>Sessions</h4>
      <div className={styles["billing__sub-title"]}>
        Accumulated session data since you first joined Orchid
      </div>
      <Sessions amplitudePageName={AMPLITUDE_PAGE_NAME} />
      <hr className={styles["billing__hr"]} />
      <div className={styles["billing__payment-info"]}>
        <h4 className={styles["billing__title"]}>My payment information</h4>
        <Table className={getClasses("table-flush", styles["billing__table"])}>
          <thead>
            <tr className="bd-12">
              <th>Payment type</th>
              <th>Status</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr className="rg-14">
              <td className={styles["billing__table-td-1"]}>Stripe</td>
              <td className="gray01">
                {user?.has_stripe_account_connected
                  ? "Connected"
                  : "Not connected"}
              </td>
              <td className="text-right">
                {user?.has_stripe_account_connected && (
                  <Button
                    className={styles["billing__button"]}
                    variant="outline-primary"
                    size="sm"
                    onClick={() => {
                      track(
                        AMPLITUDE_PAGE_NAME,
                        "go-to-stripe-button",
                        "click",
                      );
                      goToStripe();
                    }}
                  >
                    Go to Stripe
                  </Button>
                )}
              </td>
            </tr>
          </tbody>
        </Table>
      </div>
    </div>
  );
};

export default BusinessAnalytics;
